import { ace_index } from '@axo/shared/data-access/types';

interface Props {
  summary: ace_index.LoanApplicationSummary | undefined;
}

interface PartnerMapping {
  label: string;
  /** A partner may arrive under more than one value for the same field. */
  campaignContent?: string | string[];
  campaignName?: string | string[];
  campaignMedium?: string | string[];
}

function matches(expected: string | string[] | undefined, actual?: string) {
  if (!expected) return true;
  return Array.isArray(expected)
    ? expected.some((v) => v === actual)
    : expected === actual;
}

/**
 * Partner-to-campaign-code mapping. More specific entries (with more fields)
 * are listed first so they are matched before less specific ones.
 */
const partnerMappings: PartnerMapping[] = [
  {
    label: 'FK Bolig 1P',
    campaignContent: '1797',
    campaignMedium: '1952',
  },
  {
    label: 'FK Bolig',
    campaignContent: '1797',
  },
  {
    label: 'UOB Forbrug 1P',
    campaignContent: '1695',
    campaignMedium: '1928',
  },
  {
    label: 'UOB 1P',
    campaignContent: '1695',
    campaignMedium: '1927',
  },
  {
    label: 'UOB',
    campaignContent: '1695',
    campaignName: '927',
  },
  {
    label: 'UOB Forbrug',
    campaignContent: '1695',
    campaignName: '926',
  },
  {
    label: 'HKF 1P',
    campaignContent: '1800',
    campaignMedium: '1982',
  },
  {
    label: 'HKF',
    campaignContent: '1800',
  },
  {
    label: 'VK Kredit',
    campaignContent: '1716',
  },
  {
    label: 'Draivi Media',
    campaignContent: ['1370', 'Draivi Media Oy'],
  },
];

function resolvePartnerName(
  summary: ace_index.LoanApplicationSummary | undefined,
): string {
  if (!summary) return '';

  const { CampaignContent, CampaignName, CampaignMedium } = summary;

  if (!CampaignContent) return '';

  for (const mapping of partnerMappings) {
    if (
      matches(mapping.campaignContent, CampaignContent) &&
      matches(mapping.campaignName, CampaignName) &&
      matches(mapping.campaignMedium, CampaignMedium)
    ) {
      return mapping.label;
    }
  }

  return '';
}

export function PartnerName({ summary }: Props) {
  return resolvePartnerName(summary);
}
